<template>
  <div
    class="m-wap-carousel"
    :style="{
      display: extraItem.extras('carousel.display') == 1 ? 'block' : 'none'
    }"
    v-if="carousel.length > 0"
  >
    <div class="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="i in carousel" :key="i.articleId">
          <img
            :src="
              i.showImagesRealPath ||
                require('../../assets/images/carousel-default.png')
            "
            :data-url="i.url"
            alt=""
          />
          <div class="title">
            {{ i.title }}
          </div>
        </div>
      </div>
      <!-- 分页符 -->
      <div class="swiper-pagination"></div>
      <!-- 前进后退按钮 -->
    </div>
  </div>
</template>
<script>
import { interact, $subscriber } from "fire-wind-water";
//  import {browerType } from "../../common/sbase";
import { articleCategoryId, globalUserId, isSetting } from "../../common/sbase";
import service from "../../services/article";
import Swiper from "swiper/swiper-bundle.min.js";
import { updateSearchParam } from "../../common/sbase";
import "swiper/swiper-bundle.min.css";
export default {
  name: "Carousel",
  data() {
    return {
      carousel: [],
      extras: {}
    };
  },
  props: ["isSelf"],
  created() {
    $subscriber.subscribe("config-loaded", res => {
      this.extras = res;
    });

    if (!isSetting) {
      this.getRecommendedList();
    } else {
      this.carousel = [
        {
          showImagesRealPath: "./assets/images/carousel.png"
        },
        {
          showImagesRealPath: "./assets/images/carousel.png"
        }
      ];
      this.initSwiper();
    }
  },
  methods: {
    getRecommendedList() {
      var param = {
        articleCategoryId: articleCategoryId,
        globalUserId: globalUserId,
        browseInfo: interact.browseInfo,
        num: 5,
        start: 0,
        isSelf: this.isSelf ? 1 : 0
      };
      service.getRecommendedList(param).subscribe(data => {
        this.carousel = data.content.items;
        if (this.carousel.length > 0) {
          this.initSwiper();
        }
      });
    },
    initSwiper() {
      setTimeout(() => {
        this.swiper = new Swiper(
          ".swiper",
          {
            autoplay: {
              delay: 3000, //每张图间隔三秒
              disableOnInteraction: false
            }, //自动播放
            loop: true, //循环播放

            //分页器
            pagination: {
              el: ".swiper-pagination",
              bulletClass: "bullet",
              bulletActiveClass: "bullet-active"
            },
            on: {
              click: function(s, e) {
                debugger;
                let url = e.target.dataset.url;
                const href = updateSearchParam(
                  "back_returnUrl",
                  encodeURIComponent(window.location.href),
                  url
                );
                window.$sk.goto(href);
              }
            }
            //左右前进后退按钮
          },
          0
        );
      });
    },
    goArticle(i) {
      debugger;
      window.$sk.goto(i.url);
    }
  },
  components: {}
};
</script>
